/* ============================================================
   Benefits of Working TatvaSoft — benefit card carousel (Swiper 11)
   ============================================================ */

import Swiper from "swiper";
import { Navigation, Grid } from "swiper/modules";

export function initbenifitsCarousel() {
  const el = document.querySelector(".benifits-of-working-swiper");
  if (!el) return;

  const nav = document.querySelector(".benifits-nav");
  const prevButtons = document.querySelectorAll("[data-benifits-prev]");
  const nextButtons = document.querySelectorAll("[data-benifits-next]");

  let swiper = null;
  let resizeTimer = null;

  function createSwiper() {
    if (swiper) {
      swiper.destroy(true, true);
      swiper = null;
    }

    swiper = new Swiper(el, {
      modules: [Navigation, Grid],

      slidesPerView: 1,
      spaceBetween: 20,

      grid: {
        rows: 2,
        fill: "row",
      },

      loop: false,
      speed: 500,

      watchOverflow: true,
      observer: true,
      observeParents: true,
      resizeObserver: true,
      updateOnWindowResize: true,

      breakpoints: {
        576: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },

      navigation:
        prevButtons.length && nextButtons.length
          ? {
              prevEl: prevButtons[0],
              nextEl: nextButtons[0],
            }
          : undefined,
    });

    function syncNav() {
      if (nav) {
        nav.hidden = swiper.isLocked;
      }
    }

    syncNav();

    swiper.on("lock", syncNav);
    swiper.on("unlock", syncNav);
    swiper.on("resize", syncNav);
    swiper.on("update", syncNav);
  }

  createSwiper();

  // Rebuild swiper after resize
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(() => {
      createSwiper();
    }, 200);
  });

  // External navigation buttons
  prevButtons.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      if (swiper) swiper.slidePrev();
    });
  });

  nextButtons.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      if (swiper) swiper.slideNext();
    });
  });
}